import React from "react";
import Translator from "Languages/Utility/Translator";
import PageTitle from "Components/PageTitle_IconCircle/PageTitle";
import MuiPaper from "Components/MuiPaper/MuiPaper";
import CustomersTable from "./components/CustomersTable";


export default function SupportIndex() {
 
  return (
    <>
      <div className="d-flex justify-content-between mb-3">
        <PageTitle title={<Translator id="sami_support" />} />
      </div>
      <MuiPaper className="mb-5">
        <CustomersTable />
      </MuiPaper>
    </>
  );
}
